// extracted by mini-css-extract-plugin
export default {"searchPage":"search-module__searchPage__fJyyJ"};